
/**
 * 구독 상태
 */
export type SubscriptionInfoStatus = typeof SubscriptionInfoStatus[keyof typeof SubscriptionInfoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionInfoStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
